module.exports = {
  el: '#app',
  data: {
    view: '',
    params: {
      page: 1,
      userId: null,
      itemId: null
    }
  },
  filters: {
    fromNow: require('./filters/from-now'),
    domain: require('./filters/domain')
  },
  components: {
    'news-view': require('./views/news-view.vue'),
    'item-view': require('./views/item-view.vue'),
    'user-view': require('./views/user-view.vue')
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ../vue-loader/lib/selector.js?script!./src/app.vue
 ** module id = 76
 ** module chunks = 0
 **/